// Разметка ответа AI-ассистента (AiAssistant.vue) для v-html: экранирование + маленький
// markdown (ссылки, **жирный**, *курсив*, переносы строк, нумерация).
//
// ПОЧЕМУ ЭКРАНИРУЮТСЯ И КАВЫЧКИ. Ответ модели может дословно повторять данные брони или
// клиента, которые заполнил анонимный посетитель в форме виджета. Ссылка [текст](url)
// собирается подстановкой url в href="…": без экранирования " часть url закрывала атрибут и
// дописывала тегу <a> свои атрибуты (ревью api#878). После экранирования кавычка из url
// атрибут не закроет (браузер раскодирует &quot; обратно в ").
//
// ПОЧЕМУ В URL НЕТ ПРОБЕЛЬНЫХ СИМВОЛОВ. Следующие шаги вставляют свои теги, и шаг нумерации
// ставит <span class="list-item"> в начало каждой строки: для ^ с флагом m это и позиция
// после \r или U+2028/U+2029, которые в <br> не превращаются. Оказавшись внутри href, его
// кавычка закрывала атрибут. Адрес с пробелом или переносом ссылкой не становится.
//
// Ссылкой становится только http/https: схема проверяется регэкспом по уже экранированному
// тексту, поэтому её не подделать сущностью (& превращён в &amp; первым шагом), а
// [x](javascript:…) остаётся обычным текстом.
export function formatChatMessage(content) {
  if (!content) return '';

  let formatted = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  formatted = formatted.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer" class="chat-link">$1</a>'
  );

  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');
  formatted = formatted.replace(/\n/g, '<br>');
  formatted = formatted.replace(/^(\d+)\.\s(.+)$/gm, '<span class="list-item">$1. $2</span>');

  return formatted;
}
